const tones = {
  brand: { accent: "var(--brand)", bg: "var(--surface-raised)" },
  accent: { accent: "var(--accent)", bg: "var(--surface-raised)" },
  success: { accent: "var(--success)", bg: "var(--surface-raised)" },
  danger: { accent: "var(--danger)", bg: "var(--surface-raised)" },
};

export default function Toast({ title, description, tone = "brand", icon = null, onClose, style, ...rest }) {
  const t = tones[tone] || tones.brand;
  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "var(--space-3)",
        width: 340,
        maxWidth: "100%",
        background: t.bg,
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-lg)",
        border: "1px solid var(--border-subtle)",
        borderLeft: `4px solid ${t.accent}`,
        padding: "14px 16px",
        fontFamily: "var(--font-body)",
        ...style,
      }}
      {...rest}
    >
      {icon && <span style={{ display: "flex", color: t.accent, marginTop: 1 }}>{icon}</span>}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: "var(--text-sm)", fontWeight: "var(--weight-bold)", color: "var(--text-primary)" }}>{title}</div>
        {description && (
          <div style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", marginTop: 2, lineHeight: "var(--leading-normal)" }}>
            {description}
          </div>
        )}
      </div>
      {onClose && (
        <button
          type="button"
          aria-label="Dismiss"
          onClick={onClose}
          style={{ border: "none", background: "transparent", color: "var(--text-muted)", cursor: "pointer", padding: 2, display: "flex" }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}
